export const initialDatePickerState = {
  date: new Date(),
}
